import * as React from 'react'

import { Text } from '~/components/text/Text'
import { cn } from '~/styled'

export const Description = ({
  children,
  className
}: React.PropsWithChildren<{ className?: string }>) => (
  <Text size="sm" className={cn('text-grey-700', 'max-w-[80ch]', className)}>
    {children}
  </Text>
)
